import React from 'react';
import classNames from 'classnames';

import { H3 } from '../Heading/Heading';
import IconInfo from '../IconInfo/IconInfo';
import IconCircleSuccess from '../IconCircleSuccess/IconCircleSuccess';
import IconErrorCircle from '../IconErrorCircle/IconErrorCircle';
import IconAlertTriangle from '../IconAlertTriangle/IconAlertTriangle';

import css from './Disclaimer.module.css';

const icons = {
  warning: IconAlertTriangle,
  error: IconErrorCircle,
  success: IconCircleSuccess,
  info: IconInfo,
};

const Disclaimer = ({
  className,
  rootClassName,
  iconClassName,
  icon,
  level = 'info',
  heading,
  cta,
  children,
}) => {
  const Icon = icon === true ? icons[level] : icon;

  return (
    <div className={classNames(css.root || rootClassName, className, css[level])}>
      {Icon && <Icon className={classNames(css.icon, iconClassName)} />}
      {(heading || children) && (
        <div className={css.contentContainer}>
          {heading && <H3 className={css.heading}>{heading}</H3>}
          {children && <div className={css.content}>{children}</div>}
        </div>
      )}
      {cta && <div className={css.cta}>{cta}</div>}
    </div>
  );
};

export default Disclaimer;
